import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HubIcon from "@mui/icons-material/Hub";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Box, Tooltip } from "@mui/material";
import { useIntl } from "react-intl";
import { EmailProvider } from "services/KnowfullyAdminClient";

const styles = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
  },
  icon: {
    fontSize: 20,
  },
};

type EmailProviderIconProps = {
  provider?: EmailProvider;
  showName?: boolean;
};

const providerIcons: Record<EmailProvider, typeof HubIcon> = {
  [EmailProvider.SendGrid]: MailOutlineIcon,
  [EmailProvider.Hubspot]: HubIcon,
};

/**
 * Renders the provider an email was delivered through as an icon, optionally with its name.
 * A provider the client does not know about falls back to a generic icon rather than failing to render.
 */
export default function EmailProviderIcon({
  provider,
  showName = false,
}: Readonly<EmailProviderIconProps>) {
  const { formatMessage: t } = useIntl();

  if (!provider) {
    return <span>-</span>;
  }

  const Icon = providerIcons[provider] ?? HelpOutlineIcon;
  const label = t({ id: "emailProviderLabel" }, { provider });

  return (
    <Tooltip title={label}>
      <Box component="span" sx={styles.wrapper} aria-label={label}>
        <Icon sx={styles.icon} />
        {showName && <span>{provider}</span>}
      </Box>
    </Tooltip>
  );
}
